// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZdOd","questions":"styles_questions__qZz7g","footer":"styles_footer__2d9Yk"};